var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: _vm.value,
        title: `${_vm.providerLabel} Rate Limit`,
        size: "lg",
        "hide-footer": "",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "b-alert",
        {
          staticClass: "d-flex align-items-center gap-2 mb-4 rate-limit-alert",
          attrs: { show: "", variant: "secondary" },
        },
        [
          _c(
            "div",
            { staticClass: "info-icon" },
            [_c(_setup.FontAwesomeIcon, { attrs: { icon: "info" } })],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "ml-2" }, [
            _vm._v(
              "\n            Set a usage limit for " +
                _vm._s(_vm.providerLabel) +
                " requests to prevent abuse and control API costs. You can\n            define how many attempts are allowed per IP and how long users must wait before trying again.\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Attempts per IP" } },
        [
          _c("b-form-input", {
            attrs: { type: "number", min: "0", number: true },
            model: {
              value: _setup.form.attemptsPerIp,
              callback: function ($$v) {
                _vm.$set(_setup.form, "attemptsPerIp", _vm._n($$v))
              },
              expression: "form.attemptsPerIp",
            },
          }),
          _vm._v(" "),
          _c("b-form-text", [
            _vm._v(
              "Maximum number of requests allowed from the same IP. Leave empty or 0 to disable rate limiting for this\n            provider."
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Retry After (minutes)" } },
        [
          _c("b-form-input", {
            attrs: { type: "number", min: "0", number: true },
            model: {
              value: _setup.form.retryAfterMinutes,
              callback: function ($$v) {
                _vm.$set(_setup.form, "retryAfterMinutes", _vm._n($$v))
              },
              expression: "form.retryAfterMinutes",
            },
          }),
          _vm._v(" "),
          _c("b-form-text", [
            _vm._v(
              "How long users must wait to make request once the limit is reached. Leave empty or 0 to use the default\n            (10 minutes)."
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between mt-3" },
        [
          _c(
            "b-btn",
            {
              attrs: { variant: "outline-dark" },
              on: {
                click: function ($event) {
                  return _vm.$emit("input", false)
                },
              },
            },
            [_vm._v("Close")]
          ),
          _vm._v(" "),
          _c(
            _setup.LoaderBtn,
            {
              attrs: { variant: "primary", loading: _setup.saving },
              on: { click: _setup.onSave },
            },
            [_vm._v("Save")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }